/**
 * KVロゴ 残像（fixed背景投影） → .p-recruit-interview__headline で停止
 */
let kvLogoCursor = () => {
  const original = document.querySelector('.c-visual-recruit__ttl-shade .original');
  const copy = document.getElementById('js-kv-logo-copy');
  const stopTarget = document.querySelector('.p-recruit-interview__headline');
  if (!original || !copy || !stopTarget) return;

  copy.innerHTML = original.innerHTML;

  // originalのページ上の絶対座標を取得（リサイズ対応）
  const getAbsPos = () => {
    const rect = original.getBoundingClientRect();
    const scrollY = window.scrollY || window.pageYOffset;
    const scrollX = window.scrollX || window.pageXOffset;
    return {
      top: rect.top + scrollY,
      left: rect.left + scrollX,
    };
  };

  const update = () => {
    const abs = getAbsPos();
    const scrollY = window.scrollY || window.pageYOffset;
    const stopRect = stopTarget.getBoundingClientRect();
    const copyHeight = copy.offsetHeight;

    // fixed時のviewport座標 = 絶対座標（fixedはscrollに依存しないため）
    const fixedTop = abs.top;
    const fixedLeft = abs.left;

    copy.style.width = abs.width + 'px';

    // コピー下端がstopTargetの上端に達したら停止
    if (fixedTop + copyHeight >= stopRect.top + scrollY) {
      const stopAbsTop = stopRect.top + scrollY - copyHeight;
      copy.style.position = 'absolute';
      copy.style.top = stopAbsTop + 'px';
      copy.style.left = fixedLeft + 'px';
    } else {
      copy.style.position = 'fixed';
      copy.style.top = fixedTop + 'px';
      copy.style.left = fixedLeft + 'px';
    }
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });

  update();
};

/**
 * 初期化
 */
let init = () => {
  kvLogoCursor();
};

export default { init };
